import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { UploadOutlined } from '@ant-design/icons';
import { Form, Space, Button, Upload, Divider, Row, Col, Result, List } from 'antd';
import { Spinner } from 'reactstrap';
import axios from '../../utils/request';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

export class MaiRuiSubmitPhysicalExamination extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            btnEnable: false,
            errorMessage: "",
            status: "error",
            title: "应聘者体检报告提交",
            applyId: "",
            timestamp: 0,
            sign: "",
            tenantId: 0,
            //已经上传的文件列表
            uploadedFileList: [],
            maxCount: 3,
            uploadLoading: false,
        }
    };
    formRef = React.createRef()

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let tenantId = Number(urlParams.get("tenantId"));
        let applyId = urlParams.get("applyId");
        let timestamp = Number(urlParams.get("stamp"));
        let sign = urlParams.get("sign");
        if (!tenantId || !applyId || !timestamp || !sign) {
            this.setState({ errorMessage: "参数不存在！", isLoading: false, isReady: true });
            return;
        }
        this.loadPage(tenantId, applyId, timestamp, sign);
    };

    loadPage = (tenantId, applyId, timestamp, sign) => {
        const params = {
            tenantId,
            applyId,
            timestamp,
            sign
        }
        axios
            .get("/api/MaiRuiSubmitPhysicalExamination/SubmitPhysicalExaminationIniData", { params: params })
            .then(res => {
                const isSuccessValue = res.data.code == "200";
                let resdata = res.data.data;
                let errorMessage = "";
                if (!isSuccessValue) {
                    errorMessage = res.data.message
                } else {
                    if (resdata !== "" && resdata) {
                        errorMessage = "";

                        this.setState({
                            applyId: applyId,
                            timestamp: timestamp,
                            sign: sign,
                            tenantId: tenantId,
                        })
                    } else {
                        errorMessage = res.data.message
                    }
                }
                this.setState({ isLoading: false, isReady: true, errorMessage: errorMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
        );
    };


    onFinish = async (values) => {
        await this.formRef.current.validateFields().then(() => {
            this.setState({
                uploadLoading: true,
            });

            let tenantId = this.state.tenantId;
            let applyId = this.state.applyId;
            let sign = this.state.sign;
            let timestamp = this.state.timestamp;
            let physicalExaminationFiles = this.state.uploadedFileList;
            const params = {
                tenantId,
                applyId,
                timestamp,
                sign,
                physicalExaminationFiles
            }
            const bodyString = JSON.stringify(params);
            axios
                .post("/api/MaiRuiSubmitPhysicalExamination/SubmitPhysicalExaminationFiles", bodyString, {
                    headers: { "Content-Type": "application/json" },
                })
                .then((res) => {
                    console.log(res)
                    const isSuccessValue = res.data.code == "200";
                    const resback = res.data.message;
                    let resdata = res.data.data;
                    let errorMessage = "";
                    if (!isSuccessValue) {
                        errorMessage = "提交失败！" + resback
                    }
                    else {
                        if (resdata !== "" && resdata !== null && resdata) {
                            errorMessage = "提交成功！";
                            this.setState({ status: "success" });
                        }
                        else {
                            errorMessage = "提交失败！";
                        }
                    }

                    if (errorMessage !== "") {
                        this.setState({ isLoading: false, isReady: true, errorMessage });
                    }
                })
                .catch((reason) => {
                    this.setState({
                        isLoading: false,
                        isReady: true,
                        errorMessage: "操作异常，请联系管理员！",
                        uploadLoading: true,
                    });
                })
                .finally();
        })
    };

    getBase64 = (file) => {
        this.setState({ uploadLoading: true });
        const reader = new FileReader();
        reader.onload = (e) => {
            console.log("loadFile", e)
            let fileFullName = file.name;
            let base64Content = e.target.result.split(';base64,')[1];

            this.state.uploadedFileList.push({
                fileName: fileFullName,
                base64Content: base64Content
            })
            this.setState({ uploadedFileList: this.state.uploadedFileList, uploadLoading: false });
        };
        reader.readAsDataURL(file);
    }

    removeFile = (file) => {
        var index = this.state.uploadedFileList.indexOf(file);
        if (index > -1) {
            this.state.uploadedFileList.splice(index, 1);
            this.setState({ uploadedFileList: this.state.uploadedFileList, uploadLoading: false });
        }
    }

    // 上传之前
    beforeUpload = (file, fileList) => {
        if (this.state.uploadedFileList.length >= 3) {
            alert("单次最多支持上传3个附件")
            return false
        }

        if (file.size > 50 * 1024 * 1024) {
            alert("单个文件不得大于50MB")
            return false
        }

        let currntArray = this.state.uploadedFileList.filter((item) => item.fileName == file.name);
        if (currntArray !== null && currntArray.length > 0) {
            alert("同名文件已上传，请修改名字后上传")
            return false
        }

        this.getBase64(file)
        return false
    };

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<Result
                    status={this.state.status}
                    title={this.state.title}
                    subTitle={this.state.errorMessage}
                />)
            }
            else {
                return (
                    <div style={{ width: "100%", padding: "25px" }}>
                        <Divider orientation="left" style={{ fontSize: "18px" }}>提交体检报告</Divider>
                        <Row style={{ marginTop: "15px" }}>
                            <Col span={4}></Col>
                            <Col span={16}>
                                <Form onFinish={this.onFinish} ref={this.formRef}>
                                    <Form.Item>
                                        <Upload multiple={false} showUploadList={false} maxCount={this.state.maxCount} beforeUpload={this.beforeUpload}>
                                            <Button icon={<UploadOutlined />}>文件上传</Button>
                                        </Upload>
                                        <p> 文件类型：PDF,JPG等；最多上传3个文件，尽量扫描成1个文件提交。</p>
                                    </Form.Item>
                                   
                                    <Form.Item style={{
                                        height: 300,
                                    }}>
                                        <List
                                            dataSource={this.state.uploadedFileList}
                                            renderItem={(item) => (
                                                <List.Item actions={[<a class="js-hiring" onClick={() => this.removeFile(item)}>移除</a>]}>
                                                    <List.Item.Meta
                                                        title={<p>{item.fileName}</p>}
                                                    />
                                                </List.Item>
                                            )}
                                        />
                                    </Form.Item>
                                    <Form.Item>
                                        <Space style={{ float: "right" }}>
                                            <Button disabled={!this.state.uploadLoading && this.state.uploadedFileList.length == 0} htmlType="submit" type="primary">
                                                提交
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                </Form>
                            </Col>
                            <Col span={4}></Col>
                        </Row>
                    </div>
                )
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}